const LOGIN_BRANCH = "LOGIN_BRANCH";

function getLoginBranch() {
  // temp solution, localStorage sometime return value cause JSON.parse throw error
  try {
    return JSON.parse(localStorage.getItem(LOGIN_BRANCH));
  } catch {
    localStorage.clear();
    return JSON.parse(localStorage.getItem(LOGIN_BRANCH));
  }
}

function saveLoginBranch(branch) {
  localStorage.setItem(LOGIN_BRANCH, JSON.stringify(branch));
}

function removeLoginBranch() {
  localStorage.removeItem(LOGIN_BRANCH);
}

export { getLoginBranch, saveLoginBranch, removeLoginBranch };
